import React from "react";
import {
  BlockContentValue,
  Icon,
  PartialSanityImageType
} from "@silversea-ssc/ui-components-react";
import EmotionalLauncher, {
  EmotionalLauncherVariant
} from "components/EmotionalLauncher/EmotionalLauncher";
import * as styles from "./EmotionalLauncherCruiseCount.module.scss";
import { useHits } from "react-instantsearch";
import { ConfiguredInstantSearch } from "components/Algolia/ConfiguredInstantSearch";
import { formatCruisesPlural } from "src/utils/common-plurals";
import { FYCQuery } from "components/FindYourCruise/FYCQueryBuilder";
import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import ConfiguredConfigure from "components/Algolia/ConfiguredConfigure";

type Props = {
  backgroundImage: PartialSanityImageType | undefined;
  title: string | BlockContentValue;
  content: BlockContentValue | undefined;
  searchQuery: FYCQuery;
  searchIndexName: string;
  variant?: EmotionalLauncherVariant;
  tokens?: TokenValues;
};

const EmotionalLauncherCruiseCount: React.FC<
  React.PropsWithChildren<Props>
> = ({
  backgroundImage,
  title,
  content,
  children,
  searchIndexName,
  searchQuery,
  variant,
  tokens
}) => {
  return (
    <EmotionalLauncher
      title={title}
      content={content}
      backgroundImage={backgroundImage}
      variant={variant}
      tokens={tokens}
      subTitle={
        <ConfiguredInstantSearch indexName={searchIndexName}>
          <ConfiguredConfigure
            filters={searchQuery}
            attributesToRetrieve={[]}
            distinct
          />
          <CruisesCounter />
        </ConfiguredInstantSearch>
      }
    >
      {children}
    </EmotionalLauncher>
  );
};

export const CruisesCounter: React.FC = () => {
  const { results } = useHits();
  const cruises = results?.nbHits ?? 0;

  return (
    <div className={styles.cruiseCount}>
      <Icon name="ship-lateral-stroke" padding={false} />
      <p className={styles.cruiseCountLabel}>{formatCruisesPlural(cruises)}</p>
    </div>
  );
};

export default EmotionalLauncherCruiseCount;
